import isReduxFormPristine from "./isReduxFormPristine"

const isReservationPristine = () => (dispatch, getState) =>
  isReduxFormPristine(getState().form.reservation)

export default isReservationPristine
